import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DocumentoModel } from 'src/app/modules/crm/modules/applications/models/documento.model';

@Component({
  selector: 'app-documento',
  templateUrl: './documento.component.html',
  styleUrls: ['./documento.component.scss']
})
export class DocumentoComponent implements OnInit {

  @Input() model!: DocumentoModel;
  @Input() hideHeader = false;
  @Input() hideHeaderButtons = false;
  @Input() hideBorder = false;
  @Input() hideDeleteButton = false;
  @Output() modelChange = new EventEmitter<DocumentoModel>();

  @Output() edit = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<boolean>();

  constructor(private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
  }

  onUpload(item: DocumentoModel): void {
    this.model.lastModified = new Date(Date.now());
    this.modelChange.emit(item);
  }

  onDelete(event: any) {
    this.confirmationService.confirm({
      target: event.target ? event.target : undefined,
      message: 'Sei sicuro di procedere?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'No',
      accept: () => {
        this.model.path = '';
        this.model.nome = '';
        this.modelChange.emit(this.model);
      },
      reject: () => {
      }
    });
  }

  editEmitter(event: any): void {
    this.edit.emit(true);
  }

  deleteEmitter(event: any): void {
    this.delete.emit(true);
  }

}
